import { Box, ButtonBase, Paper, styled } from '@mui/material';

export const AppearanceContainer = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2.5, 3),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  backgroundColor: theme.palette.background.paper,
  boxShadow: theme.shadows[4],
  borderRadius: theme.spacing(1.5),
  width: 'fit-content',
}));

export const AppearanceCardsRow = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  gap: 20,
});

export const AppearanceCard = styled(ButtonBase, {
  shouldForwardProp: prop => prop !== 'selected',
})<{ selected?: boolean }>(({ theme, selected }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(1),
  borderRadius: theme.spacing(1.25),
  padding: theme.spacing(0.75),
  outline: 'none',
  transition: 'box-shadow 0.15s ease',
  ...(selected && {
    boxShadow: `0 0 0 2.5px ${theme.palette.primary.main}`,
  }),
}));

export const AppearanceThumbnail = styled(Box)(({ theme }) => ({
  width: 110,
  height: 78,
  borderRadius: theme.spacing(1),
  overflow: 'hidden',
  border: `1px solid ${theme.palette.divider}`,
}));
